import { useCallback } from 'react';

import { useRemoveCashbackAccountMutation } from '@ocx/graphql';

export type UseRemoveAllureCashbackAccountProps = {
  onCompleted?: () => void;
  onError?: (error: unknown) => void;
};

export const useRemoveAllureCashbackAccount = ({ onCompleted, onError }: UseRemoveAllureCashbackAccountProps = {}) => {
  const [remove, { loading }] = useRemoveCashbackAccountMutation({
    onCompleted,
    onError,
  });

  const removeCashbackAccount = useCallback(
    async (uuid: string) => {
      const result = await remove({
        variables: { uuid },
      });

      return result.data?.removeCashbackAccount;
    },
    [remove],
  );

  return { removeCashbackAccount, loading };
};
